import api from '@/api';

export default {
	state: {
		summary: null,
		progress: null
	},
	mutations: {
		SET_SCHOOL_LANGUAGES_SUMMARY (state, summary) {
			state.summary = summary;
		},
		SET_SCHOOL_LANGUAGES_PROGRESS (state, progress) {
			state.progress = progress;
		},
		CLEAR_SCHOOL_LANGUAGES_SUMMARY (state) {
			state.summary = null;
		},
		CLEAR_SCHOOL_LANGUAGES_PROGRESS (state) {
			state.progress = null;
		}
	},
	actions: {
		async setSchoolLanguagesSummary (context, summary) {
			context.commit('SET_SCHOOL_LANGUAGES_SUMMARY', summary);
		},

		async setSchoolLanguagesProgress (context, progress) {
			context.commit('SET_SCHOOL_LANGUAGES_PROGRESS', progress);
		},

		async clearSchoolLanguagesSummary (context) {
			context.commit('CLEAR_SCHOOL_LANGUAGES_SUMMARY');
		},

		async clearSchoolLanguagesProgress (context) {
			context.commit('CLEAR_SCHOOL_LANGUAGES_PROGRESS');
		}
	}
};



// WEBPACK FOOTER //
// ./src/store/languages/index.js